// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import zenscroll from 'zenscroll'

// Redux:
import { getSiteData, getSabbathSchoolData } from 'church-theme-library/redux/actions/site'
import {
	getPageData,
	getPartialPageData,
	receivePartialPage,
	receiveDkeSectionImageUpdated,
	receiveDkeSectionImageGalleryUpdated,
	receiveDkeSectionLinkUpdated,
	receiveDkeSectionFormUpdated,
	receiveDkeSectionMapUpdated,
	receiveDkeSectionAdded,
	receiveDkeSectionRemoved,
	receiveDkeSectionsReordered,
	receiveDkeSectionSettings,
	maybeUpdatePostSets
} from 'church-theme-library/redux/actions/page'

class PageData extends React.Component {
	componentDidMount() {
		const { match, history } = this.props

		if ( ! match ) {
			return
		}

		this.refresh()
		this.props.dispatch( getSiteData() )

		// Check for hash to scroll to on load:
		const locationHash = history.location.hash.slice( 1 )

		if ( locationHash ) {
			setTimeout( () => {
				const scrollElement = document.getElementById( locationHash )

				if ( scrollElement ) {
					zenscroll.toY( window.pageYOffset + scrollElement.getBoundingClientRect().top - 30 )
				}
			}, 1000 )
		}

		// Listen for editor events:
		window.addEventListener( 'dkeEditorSiteSettingsUpdated', () => {
			this.siteSettingsUpdated()
		}, false )

		window.addEventListener( 'dkeEditorPageUpdated', () => {
			this.refresh()
		}, false )

		window.addEventListener( 'dkeEditorPageDeleted', () => {
			this.refresh()
		}, false )

		window.addEventListener( 'dkeEditorPagePartiallyUpdated', ( e ) => {
			this.partialRefresh( e.detail )
		}, false )

		window.addEventListener( 'dkeEditorPageDataUpdated', ( e ) => {
			this.pageDataUpdated( e.detail )
		}, false )

		window.addEventListener( 'dkeEditorImageUpdated', ( e ) => {
			this.imageUpdated( e.detail )
		}, false )

		window.addEventListener( 'dkeEditorImageGalleryUpdated', ( e ) => {
			console.log( e.detail, 'e.detail' );
			this.imageGalleryUpdated( e.detail )
		}, false )

		window.addEventListener( 'dkeEditorLinkUpdated', ( e ) => {
			this.linkUpdated( e.detail )
		}, false )

		window.addEventListener( 'dkeEditorSectionFormUpdated', ( e ) => {
			this.formUpdated( e.detail )
		}, false )

		window.addEventListener( 'dkeEditorSectionMapUpdated', ( e ) => {
			this.mapUpdated( e.detail )
		}, false )

		window.addEventListener( 'dkeEditorSectionAdded', ( e ) => {
			this.addedSection( e.detail )
		}, false )

		window.addEventListener( 'dkeEditorSectionRemoved', ( e ) => {
			this.removedSection( e.detail )
		}, false )

		window.addEventListener( 'dkeEditorSectionsReordered', ( e ) => {
			this.reorderedSections( e.detail )
		}, false )

		window.addEventListener( 'dkeEditorSectionSettingsUpdated', ( e ) => {
			this.updatedSectionSettings( e.detail )
		}, false )
	}

	componentDidUpdate( prevProps, prevState ) {
		if ( ! this.props.match ) {
			return
		}

		const { dispatch, match, type, locale } = this.props
		const { params, path } = match

		const isAppended = this.props.pageOverride ? true : false
		const prevParams = prevProps.match.params
		const prevPath = prevProps.match.path
		const archivePageNumber = params.archivePageNumber ? params.archivePageNumber : false
		const prevArchivePageNumber = prevParams.archivePageNumber ? prevParams.archivePageNumber : false

		if (
			( '/' == path && '/' != prevProps.match.path ) ||
			( '/' == path && locale != prevProps.locale )
		) {
			this.update( 'page', 'home', false )
		} else if ( ! isAppended &&
			( type != prevProps.type || params.slug != prevParams.slug || archivePageNumber != prevArchivePageNumber )
		) {
			this.update( type, params.slug, archivePageNumber )

			// Get posts:
			dispatch( maybeUpdatePostSets( true ) )
		}
	}

	siteSettingsUpdated = () => {
		this.props.dispatch( getSiteData() )
	}

	refresh = () => {
		const { match, type, locale } = this.props
		const { params, path } = match
		const isAppended = this.props.pageOverride ? true : false
		const archivePageNumber = params.archivePageNumber ? params.archivePageNumber : false

		// Fetch new content data:
		if ( '/' == path || `/${locale}/` == path ) {
			this.update( 'page', 'home', false )
		} else if ( ! isAppended && params.slug ) {
			this.update( type, params.slug, archivePageNumber )
		} else {
			this.update( type, '', archivePageNumber )
		}
	}

	partialRefresh = ( data ) => {
		this.props.dispatch( getPartialPageData( data ) )
	}

	pageDataUpdated = ( data ) => {
		const id = data.id.replace( '_vl_', '' )

		this.props.dispatch( receivePartialPage(
			data.slug,
			{
				[ id ]: data.value
			}
		) )
	}

	imageUpdated = ( data ) => {
		if ( data.section_id ) {
			this.props.dispatch( receiveDkeSectionImageUpdated( data ) )
		}

		window.dispatchEvent( new CustomEvent( 'dkePageUpdated' ) )
	}

	imageGalleryUpdated = ( data ) => {
		if ( data.section_id ) {
			this.props.dispatch( receiveDkeSectionImageGalleryUpdated( data ) )
		}

		window.dispatchEvent( new CustomEvent( 'dkePageUpdated' ) )
	}

	linkUpdated = ( data ) => {
		if ( data.section_id ) {
			this.props.dispatch( receiveDkeSectionLinkUpdated( data ) )
		}

		window.dispatchEvent( new CustomEvent( 'dkePageUpdated' ) )
	}

	formUpdated = ( data ) => {
		if ( data.section_id ) {
			this.props.dispatch( receiveDkeSectionFormUpdated( data ) )
		}

		window.dispatchEvent( new CustomEvent( 'dkePageUpdated' ) )
	}

	mapUpdated = ( data ) => {
		if ( data.section_id ) {
			this.props.dispatch( receiveDkeSectionMapUpdated( data ) )
		}

		window.dispatchEvent( new CustomEvent( 'dkePageUpdated' ) )
	}

	addedSection = ( data ) => {
		this.props.dispatch( receiveDkeSectionAdded( data.id, data.data ) )

		window.dispatchEvent( new CustomEvent( 'dkePageUpdated' ) )
	}

	removedSection = ( data ) => {
		this.props.dispatch( receiveDkeSectionRemoved( data ) )

		window.dispatchEvent( new CustomEvent( 'dkePageUpdated' ) )
	}

	reorderedSections = ( data ) => {
		this.props.dispatch( receiveDkeSectionsReordered( data ) )

		window.dispatchEvent( new CustomEvent( 'dkePageUpdated' ) )
	}

	updatedSectionSettings = ( data ) => {
		this.props.dispatch( receiveDkeSectionSettings( data ) )

		window.dispatchEvent( new CustomEvent( 'dkePageUpdated' ) )
	}

	update = ( type, slug, archivePageNumber ) => {
		const { history, dispatch } = this.props
		const locationHash = history.location.hash.slice( 1 )
		const isAppended = this.props.pageOverride ? true : false
		let theSlug = slug,
			categorySlug = '',
			isArchive = false,
			requestOnly = false,
			number = false

		switch ( type ) {
			case 'posts':
				type = 'posts'
				isArchive = true
				categorySlug = 'latest'
				theSlug = ''
				number = 20

				break

			case 'posts-category':
				type = 'posts'
				isArchive = true
				categorySlug = slug
				theSlug = ''
				number = 20

				break

			case 'sermons':
				type = 'sermons'
				isArchive = true
				categorySlug = 'latest'
				theSlug = ''
				number = 20

				break

			case 'sermons-category':
				type = 'sermons'
				isArchive = true
				categorySlug = slug
				theSlug = ''
				number = 20

				break

			case 'sermon-series':
				type = 'sermon-series'
				isArchive = true
				categorySlug = slug
				theSlug = ''
				number = 20

				break

			case 'events':
				type = 'events'
				isArchive = true
				categorySlug = 'latest'
				theSlug = ''
				number = 20

				break

			case 'resources':
				type = 'resources'
				isArchive = true
				categorySlug = 'latest'
				theSlug = ''
				number = 200

				break

			case 'resources-category':
				type = 'resources'
				isArchive = true
				categorySlug = slug
				theSlug = ''
				number = 200

				break

			case 'galleries':
				type = 'galleries'
				isArchive = true
				categorySlug = 'latest'
				theSlug = ''
				number = 20

				break

			case 'ministries':
				type = 'ministries'
				isArchive = true
				categorySlug = 'latest'
				theSlug = ''
				number = 20

				break

			case 'bulletins':
				type = 'bulletins'
				isArchive = true
				categorySlug = 'latest'
				theSlug = ''
				number = 20

				break

			case 'videos':
				type = 'page'
				theSlug = 'videos'

				break

			case 'videos-playlist-item':
				return
		}

		// Scroll to the top when not jumping to an anchor:
		if ( ! locationHash && ! isAppended ) {
			// window.scrollTo( 0, 0 )
			window.scrollTo( { top: 0, behavior: 'smooth' } )
		}

		dispatch(
			getPageData( {
				type: type,
				isArchive: isArchive,
				slug: theSlug,
				categorySlug: categorySlug,
				number: number,
				archivePageNumber: archivePageNumber,
				requestOnly: requestOnly
			} )
		)
	}

	render() {
		return null
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected,
		selectedArchive: state.page.selectedArchive,
		locale: state.site.locale
	}
}

export default withRouter(
	connect( mapStateToProps )( PageData )
)
